import React from 'react';
import withStyles from 'react-jss';
import {
  Modal as SemanticModal,
  Button,
  Icon,
  Header,
} from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';

const styles = {
  contentHeader: {
    color: '#fff !important',
    lineHeight: '2.5rem !important',
  },
};

export type ModalError = {
  displayMessage: string;
  message: string;
};

type Props = {
  errors: ModalError[];
  onHandleClose?: () => void;
  classes: ClassProp<typeof styles>;
};

type State = {
  reportModalOpen: boolean;
};

class Modal extends React.Component<Props, State> {
  state = {
    reportModalOpen: true,
  };

  handleClose = () => {
    this.setState({ reportModalOpen: false });
    this.props.onHandleClose && this.props.onHandleClose();
  };

  renderErrors = () => {
    const { classes, errors } = this.props;

    if (typeof errors === 'string') {
      return null;
    }

    return errors.map((error: ModalError, index: number) => (
      <React.Fragment key={index}>
        <Header
          as="h3"
          className={classes.contentHeader}
          icon="browser"
          content={error.displayMessage}
        />

        <Header
          as="h4"
          className={classes.contentHeader}
          content={error.message}
        />
      </React.Fragment>
    ));
  };

  public render() {
    return (
      <SemanticModal open={this.state.reportModalOpen} basic size="small">
        <SemanticModal.Content>{this.renderErrors()}</SemanticModal.Content>

        <SemanticModal.Actions>
          <Button onClick={this.handleClose} color="green" inverted>
            <Icon name="checkmark" /> Got it
          </Button>
        </SemanticModal.Actions>
      </SemanticModal>
    );
  }
}

export default withStyles(styles)(Modal);
